import { FC, ReactNode, useCallback } from 'react'

import { useIsMounted } from '../../../hooks'
import { Injected, MetamaskIcon, WalletConnectIcon } from '../../Icons'
import { ModalContent } from './types'

const Icons: Record<string, ReactNode> = {
  Injected: <Injected width={20} height={20} />,
  MetaMask: <MetamaskIcon width={20} height={20} />,
  WalletConnect: <WalletConnectIcon width={20} height={20} />,
}

export const AccountSettingsConnectorOverlay: FC<ModalContent> = ({
  setSettings,
  isConnected,
  connectors,
  connect,
  disconnect,
  connector,
}) => {
  const isMounted = useIsMounted()

  const handleDisconnect = useCallback(() => {
    disconnect()
    setSettings(false)
  }, [disconnect, setSettings])

  if (!isMounted) return <></>
  return (
    <div className="absolute top-0 left-0 w-full h-full p-12 mt-12 bg-gray-500">
      <div className="flex flex-col justify-center gap-4 p-6 select-none animate-opacity ">
        {connectors &&
          connectors.map((c) => (
            <button
              key={c.id}
              onClick={() => {
                c.name === connector?.name && isConnected
                  ? handleDisconnect()
                  : connect && connect({ connector: c })
              }}
              className="z-50 grid self-center justify-start w-40 h-10 text-sm cursor-pointer group px-auto"
            >
              <div className="flex gap-1 text-primary">
                <div className="-ml-[6px] group-hover:opacity-50">
                  {Icons[c.name] && Icons[c.name]}
                </div>
                <span className="justify-center px-4 font-thin text-xxs tracking-default group-hover:opacity-50">
                  {c.name}
                </span>
                {c.name === connector?.name && (
                  <span className="self-center w-2 h-2 mt-1 -ml-2 bg-green-500 rounded-full cursor-default" />
                )}
              </div>
              {c.name === connector?.name && (
                <div
                  className="flex justify-center p-0 py-2 ml-2.5 -mt-4 font-thin cursor-pointer text-4xs group-hover:opacity-50 text-polling"
                  onClick={() => disconnect && disconnect()}
                >
                  Disconnect
                </div>
              )}
            </button>
          ))}
      </div>
    </div>
  )
}
